<template>
  <div id="app">
    <div class="container">
      <div class="row justify-content-center justify-content-md-start">
        <div class="col-6 col-md-4 col-lg-2">
          <img src="../assets/images/riks-logo.png" class="img-fluid " alt="SMASK Göteborg">
        </div>
      </div>
      <div class="row pt-5">
        <div class="col-12" v-if="settings" :key="settings.mode">
          <player :settings="settings"></player>
        </div>

        <div class="col-12 text-right mt-3" v-if="programDownloadUrl">
          <a :href="programDownloadUrl" target="_blank" download="RIKSSMASK2022.pdf">Ladda ner programblad</a>
        </div>
      </div>

      <div class="row mt-5 pt-5">
        <div class="col-12 col-md-8">
          <h2>HALP! <small>(Frågor och svar)</small></h2>
          <strong class="d-block h5">F: Jag får inte fram någon spelare, hur mår eran utvecklare egentligen?</strong>
          <p>S: Utvecklaren hälsar att han mår bra, men att det kan vara så att du har en s.k. Ad-blocker, eller liknande, aktiverad och då kan det hända att den blockerar den CDN som vår spelare hämtas från. Inaktivera den så kommer förhoppningsvis spelaren upp.</p>

          <strong class="d-block h5">F: Kommer ni spionera på allt jag gör?</strong>
          <p>S: Vi gjorde inte det så mycket senast, så vi tänker att vi håller nere på spionaget i år också.</p>

          <strong class="d-block h5">F: När börjar sändningen egentligen?</strong>
          <p>S: Sändningen börjar kl. 18:00 den 7 maj 2022.</p>

          <div v-if="programDownloadUrl">
            <strong class="d-block h5">F: Finns det något programblad jag kan vila ögonen på i pausen?</strong>
            <p>
              S: Absolut finns det ett programblad! Det finns en liten länk under spelaren eller så klickar du på denna rackare: <a :href="programDownloadUrl" target="_blank" download="RIKSSMASK2022.pdf">Ladda ner programblad</a>
            </p>
          </div>

          <strong class="d-block h5">F: Jag gillar bidrag X och nu vill jag rösta på det. Hur gör jag?</strong>
          <p>
            S: Ja, det bidraget var riktigt bra! När jag röstade på det så skickade jag ett SMS med texten <code>RIKSSMASK X</code> till nummer <em>72 456</em> (där X är bidragsnumret).<br>
            Det kostade mig bara 5kr + ev. operatörskostnad.<br>
            Alltså, om du skickar <code>RIKSSMASK 8</code> till <em>72 456</em> så får bidrag 8 din röst.
          </p>
        </div>
        <div class="col-md-4 d-none d-md-block text-right">
          <img src="../assets/images/halp.jpg" class="img-fluid rounded">
        </div>
      </div>

      <div class="row pb-5 mt-5 align-items-center">
        <div class="col-12 col-md text-right">
          I med och motgång tillsammas med<br>
          <img src="../assets/images/jaws-streaming.png" class="img-fluid sponsor mt-3" alt="Just Another Way of Streaming AB">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { firebase } from "@/initializers/firebase"

  import Player from "@/components/player"

  export default {
    name: "home",
    components: { Player },
    data() {
      return {
        programDownloadUrl: null,
        settings: null
      }
    },
    async mounted() {
      await this.$bind("settings", firebase.firestore().collection(`application`).doc(`settings`))
      try {
        this.programDownloadUrl = await firebase.storage().ref("files/RIKSSMASK2022.pdf").getDownloadURL()
      } catch {
        this.programDownloadUrl = null
      }
    }
  }
</script>

<style lang="scss" scoped>
  .offline {
    background-image: url("../assets/images/riks-logo.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }

  .offline-content {
    background-color: rgba($color: #FFFFFF, $alpha: .8);
  }

  .sponsor {
    max-width: 150px;
  }
</style>
